module.exports = __webpack_public_path__ + "assets/img/brigitte_bardot-e58d6f4e.jpg";